// extracted by mini-css-extract-plugin
export var callCard = "_qc-0";
export var callMessageButton = "_qc-1";
export var helpIcon = "_qc-3";
export var helpIconContainer = "_qc-4";
export var verticalDivider = "_qc-2";